(() => {
  const PRODUCT_PATH = '/products/wood-therapy-massage-set';
  const MOBILE = window.matchMedia('(max-width: 749px)');
  let ticking = false;

  const onBundleProduct = () => window.location.pathname.includes(PRODUCT_PATH);
  const setText = (el, value) => {
    if(el && typeof value === 'string' && el.textContent !== value) el.textContent = value;
  };

  function shortMobileTitle(){
    const heading = document.querySelector('.aureko-product-info h1');
    if(!heading) return;
    if(!heading.dataset.aurekoDesktopTitle){
      heading.dataset.aurekoDesktopTitle = heading.textContent.trim();
    }
    const nextTitle = MOBILE.matches ? 'Build Your Wood Therapy Ritual' : heading.dataset.aurekoDesktopTitle;
    setText(heading, nextTitle);
  }

  function selectedCard(){
    return document.querySelector('#AurekoBundlePicker .aureko-bundle-card.is-selected') ||
      document.querySelector('#AurekoBundlePicker .aureko-bundle-card[aria-pressed="true"]') ||
      document.querySelector('#AurekoBundlePicker .aureko-bundle-card');
  }

  function cardPieces(card){
    if(!card) return '';
    const data = Number(card.dataset.pieces || card.dataset.aurekoPieces || 0);
    if(data) return String(data);
    const text = card.querySelector('.aureko-bundle-card__title')?.textContent || card.textContent || '';
    const match = text.match(/\b(2|4|6|8|12|16|24)\b/);
    return match ? match[1] : '';
  }

  function updateStickyCopy(){
    if(!onBundleProduct()) return;
    const bar = document.querySelector('.aureko-mobile-product-bar');
    if(!bar) return;

    const card = selectedCard();
    const pieces = cardPieces(card);
    const strong = bar.querySelector('.aureko-mobile-product-bar__info strong');
    const price = bar.querySelector('.aureko-mobile-product-bar__info span');
    const cta = bar.querySelector('a');

    if(pieces) setText(strong, `AUREKO · ${pieces} Pieces`);

    const cardPrice = card?.querySelector('.aureko-bundle-card__price')?.textContent?.trim();
    if(cardPrice) setText(price, cardPrice);

    if(cta){
      if(cta.getAttribute('href') !== '#AurekoBundlePicker') cta.setAttribute('href','#AurekoBundlePicker');
      setText(cta,'Edit bundle');
    }
  }

  function syncSticky(){
    ticking = false;
    const bar = document.querySelector('.aureko-mobile-product-bar');
    if(!bar) return;

    if(!onBundleProduct() || !MOBILE.matches){
      bar.classList.remove('is-visible');
      return;
    }

    const zone = document.getElementById('AurekoMixBuilder') ||
      document.querySelector('.aureko-mix-builder') ||
      document.querySelector('.aureko-product-form');

    if(!zone){
      bar.classList.remove('is-visible');
      return;
    }

    const rect = zone.getBoundingClientRect();
    const show = rect.bottom < window.innerHeight * .48 && window.scrollY > 220;
    bar.classList.toggle('is-visible', show);
  }

  function requestStickySync(){
    if(ticking) return;
    ticking = true;
    requestAnimationFrame(syncSticky);
  }

  function bindPicker(){
    const picker = document.getElementById('AurekoBundlePicker');
    if(!picker || picker.dataset.aurekoMobileV4 === 'ready') return;
    picker.dataset.aurekoMobileV4 = 'ready';
    picker.setAttribute('aria-label','Choose bundle size. Swipe horizontally to compare options.');
    picker.addEventListener('click',(event) => {
      if(!event.target.closest('.aureko-bundle-card')) return;
      requestAnimationFrame(() => {
        updateStickyCopy();
        requestStickySync();
      });
    });
  }

  function bindVariant(){
    const select = document.getElementById('AurekoVariant');
    if(!select || select.dataset.aurekoMobileV4 === 'ready') return;
    select.dataset.aurekoMobileV4 = 'ready';
    select.addEventListener('change',() => requestAnimationFrame(() => {
      updateStickyCopy();
      requestStickySync();
    }));
  }

  function bindSticky(){
    const bar = document.querySelector('.aureko-mobile-product-bar');
    if(!bar || bar.dataset.aurekoMobileV4 === 'ready') return;
    bar.dataset.aurekoMobileV4 = 'ready';
    const cta = bar.querySelector('a');
    if(cta){
      cta.addEventListener('click',() => bar.classList.remove('is-visible'));
    }
  }

  function enhanceBuilder(){
    const grid = document.querySelector('.aureko-tool-grid');
    if(!grid || grid.dataset.aurekoMobileV4 === 'ready') return;
    grid.dataset.aurekoMobileV4 = 'ready';
    grid.setAttribute('aria-label','Choose your tools. Swipe horizontally to see all tools.');
  }

  function enhance(){
    if(!onBundleProduct()) return;
    document.body.classList.add('aureko-mobile-bundle-page');
    shortMobileTitle();
    bindPicker();
    bindVariant();
    bindSticky();
    enhanceBuilder();
    updateStickyCopy();
    requestStickySync();
  }

  function init(){
    if(!onBundleProduct()) return;
    enhance();
    window.addEventListener('scroll',requestStickySync,{passive:true});
    window.addEventListener('resize',() => {
      shortMobileTitle();
      requestStickySync();
    },{passive:true});
    if(MOBILE.addEventListener){
      MOBILE.addEventListener('change',() => {
        shortMobileTitle();
        requestStickySync();
      });
    }
    [120,350,700,1200,2000,3200].forEach(delay => window.setTimeout(enhance,delay));
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
